var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};


// ---------------------------------------------------------------------------
// HoverIntent
// --
function HoverIntent(elements, userConfig) {

	const defaultOptions = {
			exitDelay: 400,
			interval: 100,
			sensitivity: 7,
	};

	let config = {};
	let currX, currY, prevX, prevY;
	let allElems, pollTimer, exitTimer;

	// private methods

	// override default options with user config
	const extend = function(defaults, userArgs) {
			for (let i in userArgs) {
					defaults[i] = userArgs[i];
			}
			return defaults;
	};

	// update mouse position
	const mouseTrack = function(ev) {
			currX = ev.pageX;
			currY = ev.pageY;
	};

	// check if mouse movement has slowed enough to trigger active state
	const mouseCompare = function(targetElem) {
			const distX = prevX - currX, distY = prevY - currY;
			const distance = Math.sqrt(distX*distX + distY*distY);

			if (distance < config.sensitivity) {
					// if we re-entered an element, cancel delayed exit and clear any active elements immediately
					clearTimeout(exitTimer);
					for (let elem of allElems) {
							if (elem.isActive) {
									config.onExit(elem);
									elem.isActive = false;
							}
					}
					// trigger hover
					config.onEnter(targetElem);
					targetElem.isActive = true;
			} else {
					// update previous coordinates and try again later
					prevX = currX;
					prevY = currY;
					pollTimer = setTimeout(function() {
							mouseCompare(targetElem);
					}, config.interval);
			}
	};

	const init = function(elements, userConfig) {
			if (!userConfig || !userConfig.onEnter || !userConfig.onExit) {
					throw 'onEnter and onExit callbacks must be provided';
			}
			config = extend(defaultOptions, userConfig);
			allElems = elements;
			for (let elem of allElems) {
					// holds current element state
					elem.isActive = false;
					// keeps track of mouse position
					elem.addEventListener('mousemove', mouseTrack);
					elem.addEventListener('mouseenter', function(ev) {
							// set initial entry position
							prevX = ev.pageX;
							prevY = ev.pageY;
							// if this element is already active, cancel exit
							if (elem.isActive) {
									clearTimeout(exitTimer);
									return;
							}
							// while mouse is over this element, check distance every 100ms
							pollTimer = setTimeout(function() {
									mouseCompare(elem);
							}, config.interval);
					});
					elem.addEventListener('mouseleave', function(ev) {
							clearTimeout(pollTimer);
							if (!elem.isActive)
									return;
							exitTimer = setTimeout(function() {
									config.onExit(elem);
									elem.isActive = false;
							}, config.exitDelay);
					});
			}
	};

	init(elements, userConfig);

}

// ---------------------------------------------------------------------------
// Surefire JS
// --
class Surefire {
    constructor() {
			// Mega element.
			let $element = document.querySelectorAll('[data-js-mega-trigger]')
			// Init.
			new HoverIntent($element, {
				onEnter: function (item) {
					// What's the slug we're looking for? e.g. 'study'
					let slug = item.dataset.jsMegaTrigger
					// Find the target, in context with the current item.
					let $target = item.querySelector('[data-js-mega-target="'+slug+'"]')
					// Check if it exists.
					if (!$target) return false
					// Make the item active.
					item.classList.add('is--active')
					// Open the target.
					$target.classList.add('is--open')
					// Body
					document.body.classList.add('mega--open')
				},
				onExit: function (item) {
					if (item.querySelector('[data-js-mega-target]')) {
						// Close everything.
						item.querySelector('[data-js-mega-target]').classList.remove('is--open')
						document.body.classList.remove('mega--open')
						// Remove active states.
						item.classList.remove('is--active')
					}
				}
			})

			/**
			 *  Open / Close the mobile nav
			*/
			function toggleMobileNav() {
				const toggle = (elem) => {
					if (elem.style.display === "block") {
						elem.style.display = "none"
					} else if (elem.style.display === "none") {
						elem.style.display = "block"
					}
				}

				document.querySelector('[data-mobile-menu]').classList.toggle('is--active')
				document.querySelector('[data-hamburger] .initial').classList.toggle('sf--hidden')
				document.querySelector('[data-hamburger] .close').classList.toggle('sf--hidden')
				document.querySelector('[data-mobile-menu-child]').scrollTop = 0
				document.querySelector('body').classList.toggle('sf--overflow-hidden')
				document.querySelector('body').classList.toggle('mobile-nav-open')
				document.querySelector('body').classList.toggle('mega--open')
				toggle(document.querySelector('reviewsio-floating'))
				toggle(document.querySelector('[data-promobar]'))
			}

			/**
			* Toggle the hamburger
			*/
			const $hamburger = document.querySelector('[data-hamburger]')
			$hamburger.addEventListener('click', function(e){
				this.classList.toggle('is-active')
				e.preventDefault()
				toggleMobileNav()
			})

			/**
			* Toggle the searchbar
			*/
			let $search = document.querySelector('[data-search]')
			$search.addEventListener('click', function(e){
				document.querySelector('[data-search-container]').classList.toggle('sf--hidden')
					e.preventDefault()
			})

			/**
			* Toggle the enquire button
			*/
			let $enquireButton = document.querySelector('[data-enquire-form]')
			$enquireButton?.addEventListener('click', function(e){
				document.querySelector('[data-enquire-drawer]').classList.add('is--active')
				document.body.classList.add('enquire-drawer-active')
				e.preventDefault()
			})

			/**
			* Close the enquire drawer
			*/
			let $enquireButtonClose = document.querySelector('[data-enquire-drawer-close]')
			$enquireButtonClose?.addEventListener('click', function(e){
				document.querySelector('[data-enquire-drawer]').classList.remove('is--active')
				document.body.classList.remove('enquire-drawer-active')
				e.preventDefault()
			})

			/**
			* Toggle the child menus on mobile
			*/
			let $childToggles = document.querySelectorAll('[data-mobile-menu-child-toggle]')
			$childToggles.forEach(function (el) {
				el.addEventListener('click', function (e) {
					e.preventDefault()
					let id = this.dataset.mobileMenuChildToggle

					document.querySelector('[data-mobile-menu-child]').scrollTop = 0;
					document.querySelector('[data-mobile-menu-child]').classList.remove('is--active')
					document.querySelector('[data-mobile-menu-child="'+id+'"]').classList.add('is--active')
					document.querySelector('[data-mobile-menu]').classList.add('hide--scroll')
				})
			})

			/**
			* Toggle the child menus on mobile
			*/
			let $childToggleBacks = document.querySelectorAll('[data-mobile-menu-child-back]')
			$childToggleBacks.forEach(function (el) {
				el.addEventListener('click', function (e) {
					e.preventDefault()
					el.closest('[data-mobile-menu-child]').classList.remove('is--active')
					if (el.closest('[data-mobile-menu-child]').classList.contains('is--active')) {
							document.querySelector('[data-mobile-menu]').classList.remove('hide--scroll')
					}
			})
			})

			/**
			* Close the hamburger
			*/
			let $menuClose = document.querySelector('[data-hamburger-close]')
			$menuClose?.addEventListener('click', function(e){
					e.preventDefault()
					toggleMobileNav()
			})

			/**
			* Allow clicking outside of the mobile nav
			*/
			document.body.addEventListener('click', function(e) {
				if (!e.target.closest('.mobile-menu') && !e.target.closest('[data-hamburger]') &&
						document.body.classList.contains('mobile-nav-open')) {
							$hamburger.classList.toggle('is-active')
							toggleMobileNav()
				}
			})

			/**
			* Product detail accordion
			*/
			let $accordions = document.querySelectorAll('[data-accordion-item]')

			$accordions.forEach(function (item) {
				const itemId = Math.random().toString(36).substr(2, 9)
				item.querySelector('[data-accordion-title]').setAttribute('data-accordion-title', itemId)
				item.querySelector('[data-accordion-content]').setAttribute('data-accordion-content', itemId)
			})

			document.querySelectorAll('[data-accordion-title]').forEach(function (title) {
				title.addEventListener('click', function (e) {
					// Get the accordion id
					let accordionId = title.dataset.accordionTitle
					let $target = document.querySelector('[data-accordion-content="'+accordionId+'"]')
	
					// Trigger an event
					document.dispatchEvent(new Event('accordion:change'))
	
					// Show or hide?
					if ($target.classList.contains('sf--hidden')) {
							document.querySelector('[data-accordion-content="'+accordionId+'"]').classList.remove('sf--hidden')
							document.querySelector('[data-accordion-title="'+accordionId+'"]').classList.add('is-active')
					} else {
							document.querySelector('[data-accordion-content="'+accordionId+'"]').classList.add('sf--hidden')
							document.querySelector('[data-accordion-title="'+accordionId+'"]').classList.remove('is-active')
					}
				})
			})
		
			/**
			* Toggle read more
			*/
			const $readMoreButton = document.querySelector('[data-mobile-read-more-button]')
			if ($readMoreButton) {
				const $target = document.getElementById($readMoreButton.dataset.target)
				$readMoreButton.addEventListener('click', function(e){
					this.classList.toggle('is-active')
					e.preventDefault()
					let buttonText = (this.classList.contains('is-active') ? '&lt; Read less' : 'Read more &gt;')
					this.innerHTML = buttonText
					$target.classList.toggle('sf--hide-on-mobile')
				})
			}
    }
}

document.addEventListener('facet:update', function(event){
	document.querySelectorAll('.facet-dialog').forEach(b => b.removeAttribute('open'));
})

// Variant changed listener
document.addEventListener('variant:change', function(event) {
	sfCheckAvailability(event.detail.variant.id);
	sfCheckifSaleItem(event);
});


// Check a for sale item, and if so, calclate:
// a) The price difference
// b) The price percentage saving
// Show/hide based on variant:change event.
function sfCheckifSaleItem(event) {
	var variant = event.detail.variant
	var $saleContainer = document.querySelector('#priceSavings')

	if (!$saleContainer || !variant) return

	// Clear and hide the saving message before checking the selected variant.
	$saleContainer.hidden = true
	$saleContainer.style.display = 'none'
	$saleContainer.innerHTML = ''

	var price = Number(variant.price || 0)
	var compareAtPrice = Number(variant.compare_at_price || 0)

	// A product is on sale only when its compare-at price is higher.
	if (compareAtPrice > price) {
		var saleAmount = compareAtPrice - price
		var salePercentage = Math.floor((saleAmount / compareAtPrice) * 100)

		$saleContainer.innerHTML =
			'You save <span class="amount--saving">' +
			Shopify.formatMoney(saleAmount, '\u00A3{{amount}}') +
			'</span> (<span class="amount--percentage">' +
			salePercentage +
			'</span>%)'

		$saleContainer.hidden = false
		$saleContainer.style.display = 'block'
	}
}

// Check for available sizes +/- X sizes
function sfCheckAvailability(variantId) {
  // Check for product in window object
  if(typeof(window.sfProduct) !== 'undefined') {
    let sizeOptionName = 'Ring Size';
    let materialOptionName = 'Material';

    let sizeOption = '';
    let materialOption = '';
    for(var k in window.sfProduct.options){
      let element = window.sfProduct.options[k],
		  optionPos = parseInt(k) + 1;
      if(typeof element !== 'function') {
	    if(element == sizeOptionName) {
 		    sizeOption = 'option' + optionPos;
	    }
	    if(element == materialOptionName) {
		    materialOption = 'option' + optionPos;
	    }
      }
    }

    let selectedSize = '';
    let selectedMaterial = '';
    let variantAvailable = false;

    for(var k in window.sfVariants){
      let element = window.sfVariants[k];
			if(typeof element !== 'function') {
        if(element.id == variantId) {
					if(element.qty > 0) {
						variantAvailable = true;
					}
					selectedSize = element[sizeOption];
					selectedMaterial = element[materialOption];
          break;
				}
      }
    }

		if(!variantAvailable) {
			let sizeIndex = -1;
			let sizeVariance = 2;
			for(var k in window.sfRingSizes){
				let element = window.sfRingSizes[k];
					if(typeof element !== 'function') {
						if(element == selectedSize) {
						sizeIndex = k;
								break;
						}
				}
			}

			let startIndex = sizeIndex;
			let endIndex = sizeIndex;
			if(sizeVariance > 0) {
				for(let i=(parseInt(sizeIndex) - parseInt(sizeVariance));i<=parseInt(sizeIndex);i++) {
					if(i>=0) {
					startIndex = i;
						break;
				}
				}
				for(let i=(parseInt(sizeIndex) + parseInt(sizeVariance));i>=parseInt(sizeIndex);i--) {
					if(i<(window.sfRingSizes.length -1)) {
					endIndex = i;
					break;
				}
				}
			}

			if(sizeIndex >- 0 && startIndex >= 0 && endIndex <= (window.sfRingSizes.length)) {
				variantLoop:
				for(var kv in window.sfVariants){
					let elementV = window.sfVariants[kv];
					if(typeof elementV !== 'function') {
						if(elementV[materialOption] == selectedMaterial && parseInt(elementV.qty) > 0) {
							for(let ks=startIndex;ks<=endIndex;ks++) {
								if(window.sfRingSizes[ks] == elementV[sizeOption]) {
									variantAvailable = true;
								break variantLoop;
								}
							}
						}
					}
				}
			}
    }

		document.querySelectorAll('.buy-buttons').forEach(function(el) {
			let _this = el;
			if (!_this.classList.contains('sf-sold-out')) {
				if(variantAvailable) {
					_this.classList.remove('sf--hidden');
				} else {
					_this.classList.add('sf--hidden');
				}

				_this.querySelectorAll('.button').forEach(function(el) {
					el.setAttribute('disabled', !variantAvailable);
					if(variantAvailable) {
						el.classList.remove('button--subdued');
						document.querySelector('.sf-sold-out').classList.add('sf--hidden');
					} else {
						el.classList.add('button--subdued');
						document.querySelector('.sf-sold-out').classList.remove('sf--hidden');
					}
				});
			}
		});
  }
}

// Check if gifts need to be added
function sfCheckGifts(cart) {
	let giftRequirements = new Array();

	window.cartUpdated = false;
	// Get required gifts
	if(typeof cart.items !== 'undefined' && cart.items.length > 0) {
		for (let i=0; i < cart.items.length; i++) {
			let cartItem = cart.items[i];
			if(typeof cartItem.properties['_free_gift'] !== 'undefined') {
				let giftFound = false;
				for(let j = 0; j < giftRequirements.length; j++) {
					if(giftRequirements[j].id == cartItem.properties['_free_gift']) {
						giftFound = true;
						giftRequirements[j].qty = giftRequirements[j].qty + cartItem.quantity;
						break;
					}
				}
				if(!giftFound) {
					giftRequirements.push({ 'id': cartItem.properties['_free_gift'], 'qty': cartItem.quantity });
				}
			}
		}

		// Check if gists are required
		if(giftRequirements.length > 0) {
			for(let i = 0; i < giftRequirements.length; i++) {
				let giftFound = false;
				for(let j = 0; j < cart.items.length; j++) {
					if(cart.items[j].id == giftRequirements[i].id) {
						giftFound = true;
						if(cart.items[j].quantity != giftRequirements[i].qty) {
							cartUpdated = true;
							let data = {
								'id': cart.items[j].key,
								'quantity': giftRequirements[i].qty
							};

							fetch('/cart/change.js', {
								method: "POST",
								headers: {
									'Content-Type': 'application/json'
								},
								body: data
							})
								.then(function (res) {
									if (!res.ok) {
										throw new Error('There was an error')
									}
									window.cartUpdated = true;
									document.dispatchEvent(new CustomEvent('cart:refresh', {
									  bubbles: true
									}));
								})
								.catch(function (err) {
									console.log(err)
								})
						}
					}
				}
				// Add if not found
				if (!giftFound) {
					fetch('/cart/add.js', {
						method: "POST",
						headers: {
							'Content-Type': 'application/json'
						},
						body: {
							id: giftRequirements[i].id,
							quantity: giftRequirements[i].qty,
							properties: {
								_is_free_gift: 1
							}
						}
					})
						.then(function (res) {
							if (!res.ok) {
								throw new Error('There was an error')
							}
							document.dispatchEvent(new CustomEvent('cart:refresh', {
							  bubbles: true
							}));
						})
						.catch(function (err) {
							console.log(err)
						})
				}
			}
		}
	}
	cart = sfCheckRequiredGifts(cart);
}

// Check gifts and remove any that are no longer required
function sfCheckRequiredGifts(cart) {
	let giftRequirements = new Array();
	// Set flag
	window.cartUpdated = false;
	// Get required gifts
	if(typeof cart.items !== 'undefined' && cart.items.length > 0) {
		for (let i=0; i < cart.items.length; i++) {
			let cartItem = cart.items[i];
			if(typeof cartItem.properties['_free_gift'] !== 'undefined') {
				let giftFound = false;
				for(let j = 0; j < giftRequirements.length; j++) {
					// Update quantity if found
					if(giftRequirements[j].id == cartItem.properties['_free_gift']) {
						giftFound = true;
						giftRequirements[j].qty = giftRequirements[j].qty + cartItem.quantity;
						break;
					}
				}
				// If not found, add it
				if(!giftFound) {
					giftRequirements.push({ 'id': cartItem.properties['_free_gift'], 'qty': cartItem.quantity });
				}
			}
		}

		// Check cart against required gifts
		for (let i=0; i < cart.items.length; i++) {
			let cartItem = cart.items[i];
			if(typeof cartItem.properties['_is_free_gift'] !== 'undefined') {
				let giftRequired = false;
				for(let j = 0; j < giftRequirements.length; j++) {
					if(giftRequirements[j].id == cartItem.id) {
						giftRequired = true;
						break;
					}
				}

				// Remove if not required
				if(!giftRequired) {
					let data = {
						'id': cartItem.key,
						'quantity': 0
					};

					fetch('/cart/change.js', {
						method: "POST",
						headers: {
							'Content-Type': 'application/json'
						},
						body: data
					})
						.then(function (res) {
							if (!res.ok) {
								throw new Error('There was an error')
							}
							window.cartUpdated = true;
							document.dispatchEvent(new CustomEvent('cart:refresh', {
							  bubbles: true
							}));
						})
						.catch(function (err) {
							console.log(err)
						})
				}
			}
		}
	}

	return cart;
}

// Refresh cart quantities after gif update
function sfUpdateCartQuantities(cart) {
	if(cart.items.length > 0) {
		for(let i = 0;i < cart.items.length; i++) {
			document.querySelector('input[data-line-key="'+cart.items[i].key+'"]').value = cart.items[i].quantity;
		}
	}
}

// Wait until cart updated flag is set
function sfCheckCartUpdated(attempt = 0) {
    if(window.cartUpdated === false) {
       if (attempt < 50) window.setTimeout(() => sfCheckCartUpdated(attempt + 1), 100); /* this checks the flag every 100 milliseconds*/
		} else {
			fetch('/cart.js').then(function (res) {
					if (!res.ok) {
						throw new Error('There was an error')
					}
					return res.json()
				})
				.then(function (data) {
					if(data.items.length > 0) {
						sfUpdateCartQuantities(data);
					} else {
						location.reload();
					}
				})
				.catch(function (err) {
					console.log(err)
				})
    }
}

function sfInitFilterCloser() {
	document.querySelector('.sr-only').addEventListener('change', function(){
		document.querySelector( '[aria-expanded="true"]' ).dispatchEvent(new Event('click'));
	});
}

// Run Surefire after page load
document.addEventListener("DOMContentLoaded" ,function() {
	new Surefire()

	if (window.innerWidth >= 1024) {
		document.querySelector('[data-accordion-title]')?.dispatchEvent(new Event('click'));
	}

	// Get current ID
	let variantId = document.querySelector('#sf_selected_variant')?.value;
    
	// Check for available sizes
	sfCheckAvailability(variantId);

	// Set flag so we only try once
	window.giftAdded = false;

	// Add event listener for cart:change
	document.addEventListener("cart:change", (event) => {
	  // Check flag
	  if(window.giftAdded == false) {
			// Check if gifts need to be added / removed
			sfCheckGifts(event.detail["cart"]);
	  }

		if (event.detail["cart"].item_count > 0) {
			document.querySelector('[data-cart-count]').classList.add('is--active')
		} else {
		  document.querySelector('[data-cart-count]').classList.remove('is--active')
		}
	});

	// Re-check on cart page load
	if(typeof window.shopifyTemplate !== 'undefined' && window.shopifyTemplate == 'cart' && window.shopifyCart?.items?.some(item => item.properties?._free_gift || item.properties?._is_free_gift)) {
		let cart = sfCheckGifts(window.shopifyCart);
		sfCheckCartUpdated();
	}
})